import { Typography } from "@mui/material";
import React from "react";
import { CollectionGroupDetailsDto } from "../../../../common/service/server/dto/CollectionGroupDto";
import { UUIDString } from "../../../../common/service/server/Types";
import { ToggleButton } from "../../buttons/ToggleButton";

interface Props {
  groupId: UUIDString;
  included: boolean;
}
export const CollectionGroupMultiSelect: React.FC<{
  collectionGroups: CollectionGroupDetailsDto[];
  selected: string[];
  pending: string[];
  onChange: ({ groupId, included }: Props) => void;
}> = ({ collectionGroups, selected, pending, onChange }) => {
  return (
    <ul className="vertical-list">
      {collectionGroups.map((group) => (
        <li key={group.id} className="mt-mdlg">
          <ToggleButton
            checked={selected.some((s) => s === group.id)}
            loading={pending.some((s) => s === group.id)}
            onChange={(included) => onChange({ groupId: group.id, included })}
          >
            <div>
              <Typography>{group.name}</Typography>
            </div>
          </ToggleButton>
        </li>
      ))}
    </ul>
  );
};
